"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDownIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const create_icon_1 = require("../utils/create-icon");
exports.ChevronDownIcon = (0, create_icon_1.createIcon)({
    displayName: "ChevronDown",
    path: ((0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "m12.05,18.45L.1,6.43c-.14-.21-.14-.48,0-.66.17-.23.51-.29.77-.12,3.72,3.75,7.45,7.5,11.17,11.24l11.02-11.09c.21-.21.53-.22.74-.06.24.19.28.58.04.84-3.93,3.96-7.86,7.91-11.79,11.87Z" })),
});
